module.exports = __webpack_public_path__ + "static/img/icon_second.661e427e.png";